import VueTelInput from './VueTelInput.vue';

// Drop-in Vue 3 replacement for the `vue-tel-input` (v4) plugin. Keeps the same
// install signature: `app.use(VueTelInput)` registers the global
// `<vue-tel-input>` / `<VueTelInput>` component. Per-instance props cover all
// configuration we use, so there's no global-options merge.
const plugin = {
  install(app) {
    app.component('VueTelInput', VueTelInput);
  },
};

export { VueTelInput };
export default plugin;
